import {
  deleteApiV2IntegrationsIntegraId,
  getApiV2IntegrationsGochatAccountId,
  putApiV2IntegrationsGochatAccountId,
  type TypesUpdateIsActiveRequest,
} from './generate/integrations.gen';
import type { IUpdateIntegrationsListDataDto } from './types';

export const getIntegrationsByAccountId = getApiV2IntegrationsGochatAccountId;

export const deleteIntegrationById = deleteApiV2IntegrationsIntegraId;

export const updateIntegrationsByAccountId = (
  accountId: string,
  data: IUpdateIntegrationsListDataDto
) => putApiV2IntegrationsGochatAccountId(
  accountId,
  data as TypesUpdateIsActiveRequest
);

export type {
  IIntegrationsListResponseDto,
  IUpdateIntegrationsListDataDto,
  IUpdateIntegrationsListResponseDto,
} from './types';
